function rolesOf(user) {
  if (!user) return []
  const roles = Array.isArray(user.roles) ? user.roles : []
  return user.role ? [...roles, user.role] : roles
}

function isSupportAgent(user) {
  return rolesOf(user).includes('support_agent')
}

function canManageSupportAssignments(user) {
  return rolesOf(user).includes('admin')
}

function supportHomeRoute(user) {
  return isSupportAgent(user) ? 'admin-support-tickets' : 'dashboard'
}

module.exports = {
  isSupportAgent,
  canManageSupportAssignments,
  supportHomeRoute,
}
